import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';
import { DateTime } from 'src_common/utils/time/time';
import { DateTimeRangeState } from './DateTimeRange.state';
import { InputWrapper, InputsContainer } from './DateTimeRange.style';

export interface RangeType {
    startDate?: string;
    endDate?: string;
}

export interface DateTimeRangePropsType {
    value: RangeType;
    maxDate?: string;
    timeFormat?: string;
    dateFormat?: string;
    onChange?: (range: RangeType) => void;
    requiredStart?: boolean;
    requiredEnd?: boolean;
}

export const DateTimeRange = observer('DateTimeRange', (props: DateTimeRangePropsType) => {
    const { maxDate, timeFormat, dateFormat } = props;
    const [state] = useState(() => new DateTimeRangeState(props));
    const { startDateValue, endDateValue } = state;

    const startDateTime = DateTime.from(startDateValue);
    const endDateTime = DateTime.from(endDateValue);
    const maxDateTime = DateTime.from(maxDate);

    let maxStartDate: string | undefined;

    if (endDateTime !== null && maxDateTime !== null) {
        maxStartDate = maxDateTime.diffInDays(endDateTime) > 0 ? maxDate : endDateValue;
    }

    return (
        <InputsContainer>
            <InputWrapper data-test='start-date-input-wrapper'>
                <DateTimeInput
                    maxDate={maxStartDate}
                    value={startDateTime === null ? '' : startDateTime.toISOString()}
                    timeFormat={timeFormat}
                    dateFormat={dateFormat}
                    rangeInput={true}
                    required={props.requiredStart ?? true}
                    onChange={state.changeStartDate}
                />
            </InputWrapper>
            <InputWrapper data-test='end-date-input-wrapper'>
                <DateTimeInput
                    minDate={startDateValue}
                    maxDate={maxDate}
                    value={endDateTime === null ? '' : endDateTime.toISOString()}
                    timeFormat={timeFormat}
                    dateFormat={dateFormat}
                    rangeInput={true}
                    required={props.requiredEnd ?? true}
                    onChange={state.changeEndDate}
                />
            </InputWrapper>
        </InputsContainer>
    );
});
